import { useTranslation } from 'react-i18next'
import { Search } from 'lucide-react'

/**
 * Branding header shown above the registration card: round logo, page title
 * and a short subtitle. Pure presentation — no state.
 */
export function RegisterHeader() {
  const { t } = useTranslation()
  return (
    <div className="text-center">
      <div className="mx-auto h-14 w-14 rounded-full bg-primary flex items-center justify-center mb-4">
        <Search className="h-6 w-6 text-primary-foreground" />
      </div>
      <h1 className="font-serif text-3xl font-bold">{t('auth.register_title')}</h1>
      <p className="text-muted-foreground mt-2 text-sm">{t('auth.register_subtitle')}</p>
    </div>
  )
}
